import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import RadarPlot from "./RadarPlot";
import AreaPlot from "./AreaPlot";
import LinePlot from "./LinePlot";
import { Text } from "../../styles/Global";
import {
  usePlayerRankMutation,
  usePlayerDuprDoublesMutation,
  usePlayerDuprSinglesMutation,
} from "../../services/playerApi";
import SkeletonLoader from "../../components/SkeletonLoader";
import { setChartData } from "../../features/player/chartDataSlice";

const mapDispatch = { setChartData };

const RankChart = ({
  requestBody,
  sport,
  userID,
  FormatTimestamps,
  setChartData,
  type,
}) => {
  const savedChartData = useSelector((state) => state.chartData.playerRank);
  const [data, setData] = useState(savedChartData);
  const [
    getPlayerRank,
    {
      data: playerRankData,
      error: playerRankError,
      isLoading: playerRankLoading,
    },
  ] = usePlayerRankMutation();

  useEffect(() => {
      console.log("gettingPlayerRank");
      getPlayerRank(requestBody);
  }, []);

  useEffect(() => {
    if (playerRankData) {
      setChartData({ playerRank: playerRankData });
      setData(playerRankData);
    }
  }, [playerRankData]);

  console.log("playerRankData: ", playerRankData);
  console.log("rankChart data: ", data);

  return data ? (
    <div style={{ paddingTop: 25 }}>
      {data && data.chart.length ? (
        <LinePlot
          type="rank"
          x="timestamp"
          y="rank"
          autoHeight={true}
          data={FormatTimestamps(data.chart)}
          total={sport === "pickleball" ? data.dupr : data.rankTotal}
        />
      ) : (
        <div
          style={{
            textAlign: "center",
            alignSelf: "center",
            marginTop: 25,
          }}
        >
          <Text>No Rank Data available yet</Text>
        </div>
      )}
    </div>
  ) : (
    <SkeletonLoader h1={200} />
  );
};

export default connect(null, mapDispatch)(RankChart);
